 /* eslint-disable no-undef*/
import GanttUtils from '@/utils/gantt-utils'
import { log, warn, error } from '@/utils/debugLogger';

export const WORK_DAY = 8;
export    const resourceConfig = {
    scale_height: 30,
    row_height: 45,
    scales: [
        { unit: "day", step: 1, date: "%d %M" }
    ],
    columns: [
        {
            name: "name", label: "Name", tree: true, width: 250, template: function (resource) {
                return resource.text;
            }, resize: true
        },
        {
            name: "progress", label: "Complete", align: "center", template: resource_progress_template, resize: true 
        },
        {
            name: "workload", label: "Workload", align: "center", template: resource_work_load_template, resize: true
        },

        {
            name: "capacity", label: "Capacity", align: "center", template: resource_capacity_template
        }

    ]
};  
export    function resource_progress_template(resource) {
    // const store = gantt.getDatastore(gantt.config.resource_store);
     let totalToDo = 0,
         totalDone = 0;
  
     const assignments = GanttUtils.getResourceAssignments(resource.id);

     assignments.forEach(function (assignment) {
         const task = gantt.getTask(assignment.task_id);
         totalToDo += task.duration;
         totalDone += task.duration * (task.progress/100 || 0);
     });

     let completion = 0;
     if (totalToDo) {
         completion = (totalDone / totalToDo) * 100;
     }

     return Math.floor(completion) + "%";
 }

 export function resource_work_load_template (resource) {

    let totalDuration = 0;

    const assignments = GanttUtils.getResourceAssignments(resource.id);
    assignments.forEach(function (assignment) {
        const task = gantt.getTask(assignment.task_id);
        totalDuration +=task.duration;
    });

    return (totalDuration || 0) + "h";

}

export function resource_capacity_template(resource) {
    const store = gantt.getDatastore(gantt.config.resource_store);
    const n = store.hasChild(resource.id) ? store.getChildren(resource.id).length : 1

    const state = gantt.getState();

    return gantt.calculateDuration(state.min_date, state.max_date) * n * WORK_DAY + "h";
}

export  function resource_cell_value_template(start_date, end_date, resource, tasks, assignments, parentIteration) {
    
    const store = gantt.getDatastore(gantt.config.resource_store);
    if (store.hasChild(resource.id)) {
        let parentResult = 0
        store.eachItem(function (child) {
            const assignments = gantt.getResourceAssignments(child.id);
            const assignedTasks = [];
            assignments.forEach(function (assignment) {
                const task = gantt.getTask(assignment.task_id)
                if (!(+task.start_date > +start_date || +task.end_date < +end_date)) {
                    assignedTasks.push(task)
                }

            })
            parentResult += gantt.templates.resource_cell_value(start_date, end_date, child, assignedTasks, assignments, true)
        }, resource.id);
        if (parentResult % 1) {
            parentResult = Math.round(parentResult * 10) / 10;
        }
        if (parentResult) {
            return "<div>" + parentResult + "</div>";
        }
        else {
            return ""
        }


    }

    let result = 0;

    tasks.forEach(function (item) {
        const assignments = gantt.getResourceAssignments(resource.id, item.id);
        assignments.forEach(function (assignment) {
            if (gantt.$resourceMode == "hours") {
                result += Number(assignment.value);
            }
            else {
                ++result;
            }
            
        });
    });

    if (result % 1) {
        result = Math.round(result * 10) / 10;
    }
    if (parentIteration) {
        return result
    }

    if (result) {
        return "<div>" + result + "</div>";
    }
    else {
        return ""
    }
}

  export function resource_cell_class_template(start_date, end_date, resource, tasks) {
    log(resource, tasks)
    const css = [];
    css.push("resource_marker");

    let result = 0;

    tasks.forEach(function (item) {
        const assignments = gantt.getResourceAssignments(resource.id, item.id);
        assignments.forEach(function (assignment) {
            result += assignment.value * 1;
        });
    });
    if (result % 1) {
        result = Math.round(result * 10) / 10;
    }

    if (result <= 8) {
        css.push("workday_ok");
    } else {
        css.push("workday_over");
    }
    return css.join(" ");
}
export  function ganttLayoutConfig(showResourcePanel=false,resourceHistogram=false){
    var config={
        css: "gantt_container",
        rows: [
          {
            // layout for default Grid and Timeline
            cols: [
              {view: "grid", group:"grids", scrollY: "scrollVer"},
              {resizer: true, width: 1},
              {view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer"},
              {view: "scrollbar", id: "scrollVer", group:"vertical"}
            ],
            gravity:2
          },
          // { resizer: true, width: 1}
        ]
    };

    if(showResourcePanel){
        config.rows.push(
            {
                height: 50,
                cols: [
                    { html: " ", css: "resource-select-panel", group: "grids" },
                    { resizer: true, width: 1 },
                    {
                        html: "<div class='form-control-wrapper'><label class='active mr-2 form-control' ><input checked type='radio' name='resource-mode' value='hours'>Hours per day </label> </div>" +
                            "<div class='form-control-wrapper'><label class='form-control' > <input type='radio' name='resource-mode' value='tasks'> Tasks per day </label></div>", css: "resource-controls"
                    }
                ]
            },
            {
            // layout for Grid and Timeline of resource panel
            gravity:1,
            id: "resources",
            config: resourceConfig, // config for Grid and Timeline
            //templates: resourceTemplates, // templates for Grid and Timeline
            cols: [
                { view: "resourceGrid", group:"grids", scrollY: "resourceVScroll" },
                { resizer: true, width: 1},
                resourceHistogram? { view: "resourceHistogram", capacity:24, scrollX: "scrollHor", 
                    scrollY: "resourceVScroll"}:{ view: "resourceTimeline", scrollX: "scrollHor", scrollY: "resourceVScroll" },
                { view: "scrollbar", id: "resourceVScroll", group:"vertical"}
            ]
        },
        {view: "scrollbar", id: "scrollHor"});
        
   
    }
    else {
      config.rows.push({ view: "scrollbar", id: "scrollHor" })
    }
   

    return config;
}

export function histogram_cell_capacity_template(start_date, end_date, resource) {
    if (!gantt.isWorkTime(start_date)) {
        return 0;
    }
    return GanttUtils.getCapacity(start_date, end_date,resource);
}

export function histogram_cell_allocated_template(start_date, end_date, resource, tasks) {
    return GanttUtils.getAllocatedValue(tasks, resource);
}

export function    histogram_cell_label_template(start_date, end_date, resource, tasks) {
    if (tasks.length && !gantt.$resourcesStore.hasChild(resource.id)) {
        return GanttUtils.getAllocatedValue(tasks, resource) + "/" + GanttUtils.getCapacity(start_date,end_date, resource);
    } else {
        if (!gantt.$resourcesStore.hasChild(resource.id)) {
            return '&ndash;';
        }
        return '';
    }
}

export function histogram_cell_class_template(start_date, end_date, resource, tasks) {
    if (GanttUtils.getAllocatedValue(tasks, resource) > GanttUtils.getCapacity(start_date, end_date,resource)) {
        return "column_overload"
    }
}

export  function week_scale_template(date) {
    var dateToStr = gantt.date.date_to_str('%d %M');
    var weekNum = gantt.date.date_to_str('(week %W)');
    var endDate = gantt.date.add(gantt.date.add(date, 1, 'week'), -1, 'day');
    return dateToStr(date) + ' - ' + dateToStr(endDate) + ' ' + weekNum(date);
  }

  export function task_cell_class_template (item, date) {
    if (date.getDay() === 0 || date.getDay() === 6) {
      // 0 = Sunday, 6 = Saturday
      return 'weekend';
    }
    return '';
  }

export function  timeline_cell_class_template  (task, date) {
    if (!gantt.isWorkTime(date))
      return "week_end";
    return "";
  }

  export const ganttZoomConfig= {
    levels: [
      // hours
      {
        name: 'hour',
        scale_height: 60,
        scales: [
          { unit: 'day', step: 1, format: '%d %M' },
          { unit: 'hour', step: 1, format: '%H:%i' },
        ],
      },
      // days
      {
        name: 'day',
        scale_height:40,
        scales: [
          { unit: 'day', step: 1, format: '%d %M' },
          // { unit: 'hour', step: 1, format: '%H:%i' },
        ],
      },
      // weeks
      {
        name: 'week',
        scale_height: 60,
        scales: [
          {
            unit: 'week',
            step: 1,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str('%d %M');
              var endDate = gantt.date.add(date, -6, 'day');
              var weekNum = gantt.date.date_to_str('%W')(date);
              return '#' + weekNum + ', ' + dateToStr(date) + ' - ' + dateToStr(endDate);
            },
          },
          { unit: 'day', step: 1, format: '%j %D' },
          // { unit: 'hour', step: 1, format: '%H:%i' },
        ],
      },
      // months
      {
        name: 'month',
        scale_height: 60,
        scales: [
          { unit: 'month', step: 1, format: '%F, %Y' },
          {
            unit: 'week',
            step: 1,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str('%d %M');
              var endDate = gantt.date.add(gantt.date.add(date, 1, 'week'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            },
          },
        ],
      },
      // quarters
      {
        name: 'quarter',
        height: 60,
        scales: [
          {
            unit: 'quarter',
            step: 3,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str('%M %y');
              var endDate = gantt.date.add(gantt.date.add(date, 3, 'month'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            },
          },
          { unit: 'month', step: 1, format: '%M' },
        ],
      },
      // years
      {
        name: 'year',
        scale_height: 60,
        scales: [
          {
            unit: 'year',
            step: 5,
            format: function (date) {
              var dateToStr = gantt.date.date_to_str('%Y');
              var endDate = gantt.date.add(gantt.date.add(date, 5, 'year'), -1, 'day');
              return dateToStr(date) + ' - ' + dateToStr(endDate);
            },
          },
        ],
      },
    ],
    useKey: 'ctrlKey',
    trigger: 'wheel',
    element: function () {
      return gantt.$root.querySelector('.gantt_task');
    },
  };

  export const  ganttSelectionHeader =` <div class="d-flex justify-center h-100" data-action="task-select">
              <input type="checkbox" id="tasks-select-header" onclick="onTaskSelectHeader(event)" >
            </div>`;

  export const ganttColumnsConfig=[
    {
      name: 'select',
      label: ganttSelectionHeader,
      max_width: 40,
      template: gantt_selection_column_template,
      sort: false,
    },

    { name: 'text', label: 'Task name', tree: true, width: 350, resize: true },
    {
      name: 'start_date',
      label: 'Start time',
      align: 'center',
      width: 100,
      hide: true,
      resize: true,
    },
    {
      name: 'end_date',
      label: 'End time',
      align: 'center',
      width: 100,
      hide: true,
    },
    {
      name: 'duration',
      label: 'Duration',
      align: 'center',
      width: 100,
      hide: true,
    },
    {
      name: 'show-in-3d',
      label: '3D',
      width: 50,
      template: showIn3d_template,
      sort: false,
      resize: true,
    },
    {
      name: 'custom-actions',
      label: 'Actions',
      width: 100,
      template:  actions_template,
      sort: false,
      resize: true,
    },
  ];

  export function gantt_selection_column_template(item) {
    return ` <div class="d-flex justify-center h-100" data-action="task-select">
          <input type="checkbox" id="${item.id}" name="${item.id}"  ${
      item.$selected ? 'checked="true"' : ''
    }   >
        </div>`;
  }


  export function  showIn3d_template(task) {
    return task.forgeTagsIds?.length
      ? `
        <div class="d-flex justify-center">
          <button class="task-action" data-action="isolate3d">
            <i class="mdi mdi-loupe"></i>
          </button>
        </div>
      `
      : '';
  }
  export function   actions_template(task) {
    if (task.propertyName === 'Project.ContractId') {
     return '';
    }
    if (task.propertyName === 'ProjectId') {
     return '';
    }
    return `
        <div class="d-flex justify-center">
          <button class="task-actions-menu ml-1" data-action="showActionsMenu">
            <i class="mdi mdi-dots-vertical"></i>
          </button>
        </div>
      `;
  }

  /**
   * Copy-link template: rendered on each task row, beside the 3-dots actions
   * column. Click delegates to `data-action="copyLink"` switch case in
   * Gantt.ganttOnTaskClicked → copyTaskLink(task) → SHARE_INTENT registry.
   *
   * Visibility (matches the copy-link feature plan's universal rule):
   *   - Hidden for grouping rows (Project / Contract level)
   *   - VISIBLE for all task rows, including those without forgeTagsIds.
   *     Per the rule, a no-tags task copies a `task-board` URL for the
   *     current facility — still useful, lets the recipient see the task
   *     on the Kanban board even if it has no 3D / 360 representation.
   */
  export function copyLink_template(task) {
    if (task.propertyName === 'Project.ContractId') return '';
    if (task.propertyName === 'ProjectId') return '';
    return `
        <div class="d-flex justify-center">
          <button class="task-action" data-action="copyLink" title="Copy link to task">
            <i class="mdi mdi-link-variant"></i>
          </button>
        </div>
      `;
  }
